import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-container" }
const _hoisted_3 = { class: "footer-column" }
const _hoisted_4 = { class: "footer-links" }
const _hoisted_5 = { href: "#home" }
const _hoisted_6 = { href: "#about" }
const _hoisted_7 = { href: "#services" }
const _hoisted_8 = { href: "#references" }
const _hoisted_9 = { href: "#reviews" }
const _hoisted_10 = { href: "#contact" }
const _hoisted_11 = { class: "footer-column" }
const _hoisted_12 = { class: "footer-contact" }
const _hoisted_13 = { class: "contact-item" }
const _hoisted_14 = { class: "contact-item" }
const _hoisted_15 = { class: "contact-item" }

import "@/assets/styles/footer.css";

import {ChevronRight, Mail, MapPin, Phone} from "lucide-vue-next";

export default /*@__PURE__*/_defineComponent({
  __name: 'FooterImpressum',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "footer-column" }, [
        _createElementVNode("div", { class: "footer-brand" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Logo",
            class: "footer-logo"
          }),
          _createElementVNode("div", null, [
            _createElementVNode("h2", null, "TestGarten"),
            _createElementVNode("span", null, "Garten- & Landschaftsbau")
          ])
        ]),
        _createElementVNode("p", null, " Professioneller Garten- & Landschaftsbau für moderne Außenanlagen, Pflege und individuelle Projekte. ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Navigation", -1)),
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createVNode(_unref(ChevronRight), { size: "18" }),
            _cache[0] || (_cache[0] = _createTextVNode(" Home ", -1))
          ]),
          _createElementVNode("a", _hoisted_6, [
            _createVNode(_unref(ChevronRight), { size: "18" }),
            _cache[1] || (_cache[1] = _createTextVNode(" Über uns ", -1))
          ]),
          _createElementVNode("a", _hoisted_7, [
            _createVNode(_unref(ChevronRight), { size: "18" }),
            _cache[2] || (_cache[2] = _createTextVNode(" Leistungen ", -1))
          ]),
          _createElementVNode("a", _hoisted_8, [
            _createVNode(_unref(ChevronRight), { size: "18" }),
            _cache[3] || (_cache[3] = _createTextVNode(" Referenzen ", -1))
          ]),
          _createElementVNode("a", _hoisted_9, [
            _createVNode(_unref(ChevronRight), { size: "18" }),
            _cache[4] || (_cache[4] = _createTextVNode(" Bewertungen ", -1))
          ]),
          _createElementVNode("a", _hoisted_10, [
            _createVNode(_unref(ChevronRight), { size: "18" }),
            _cache[5] || (_cache[5] = _createTextVNode(" Kontakt ", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Kontakt", -1)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(MapPin), { size: "18" }),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Wiesbaden & Umgebung", -1))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(Phone), { size: "18" }),
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "+49 123 456789", -1))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(Mail), { size: "18" }),
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "info@testgarten.de", -1))
          ])
        ])
      ])
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "footer-bottom" }, [
      _createElementVNode("p", null, " © 2026 TestGarten — Alle Rechte vorbehalten "),
      _createElementVNode("div", { class: "footer-bottom-links" }, [
        _createElementVNode("a", { href: "/impressum" }, "Impressum"),
        _createElementVNode("a", { href: "/datenschutz" }, "Datenschutz")
      ])
    ], -1))
  ]))
}
}

})